import React, {useEffect, useRef, useState} from 'react';
import AppLayout from "../../../components/AppLayout";
import {Helmet} from "react-helmet";
import HeaderAI from "../../../components/AI/Header/Header";
import {useTranslation} from "react-i18next";
import Button from "../../../components/Button";
import FakeCart from "../../../components/FakeCart";
import SideBarMenu from "../../../components/AI/SideBarMenu/SideBarMenu";
import ProductModal from "../../../components/ProductModal";
import useGlobal from "../../../state/useGlobal";
import history from "../../../routes/history";
import toast from "react-hot-toast";
import FakeCartModal from "../../../components/FakeCartModal";
import {Redirect} from "react-router-dom";
import apiCRM from "../../../services/apiCRM";
import api from "../../../services/api";
import classNames from "classnames";
import TeacherEditionV3 from "../../../components/AI/TeacherEdition/TeacherEditionV3";
import CardItem from "../../../components/AI/CardItem/CardItem";
import Waiting from "../../../components/AI/Waiting/Waiting";
import Config from "../../../config";
import GO_IMG from "../../../images/calcuso-ai/group-order.png";
import mixpanel from "mixpanel-browser";
import ScrollToFieldError from "../../../components/ScrollToFieldError";
import Input from "../../../components/Forms/Input";
import * as Yup from "yup";
import {Formik} from "formik";
import PEEKAPOO_MONKEY from "../../../images/calcuso-ai/peekaboo-monkey.png";
import CardFreeProduct from "../../../components/AI/CardItem/CardFreeProduct";
import FreeShipBanner from "../../../components/FreeShipBanner/FreeShipBanner";
import ConfirmModal from "../../../components/ConfirmModal";

export default function ProductScreen({ga4}) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false)
    const [globalState, globalActions] = useGlobal();
    const {calcusoAI, teacherEdition, checkout} = globalState;
    const {uuid, is_analyzed, is_parent_letter, is_not_found_product, group_order_school_code, is_calcuso_parent_letter} = calcusoAI;
    const [cartItem, setCartItem] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const [currentCardIndex, setCurrentCardIndex] = useState(-1);
    const [items, setItems] = useState(null);
    const [cartRules, setCartRules] = useState(null);
    const [settings, setSettings] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingRedirect, setIsLoadingRedirect] = useState(false);
    const [isLoadingISBN, setIsLoadingISBN] = useState(true);
    const [preCheckText, setPreCheckText] = useState('');
    const [extendedMessage, setExtendedMessage] = useState('');
    const navigatingToCart = useRef(false);
    const {store} = checkout;
    const fakeItems = new Array(5).fill({});

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isWaiting) {
                e.preventDefault();
                e.returnValue = t('Are you sure you want to leave?');
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isWaiting]);

    useEffect(() => {
        window.history.pushState(null, document.title, window.location.href);
        
        const handlePopState = (event) => {
            event.preventDefault();

            if (navigatingToCart.current) return;
            
            window.history.pushState(null, document.title, window.location.href);
            
            globalActions.openConfirmModal(() => {
                history.push('/');
                globalActions.closeConfirmModal();
            });
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [globalActions, t, history]);

    useEffect(() => {
        const init = async () => {
            const calcusoAI = globalState.calcusoAI;
            const calcusoAIShare = globalState.calcusoAIShare;

            mixpanel.track_pageview({
                page: "product",
                uuid: calcusoAI.uuid ?? null,
                refer_code: calcusoAIShare.refer_code ?? null
            });

            if (!uuid) {
                history.push('/');
                return;
            }

            if (is_analyzed === false) {
                setIsWaiting(true);
                analyze();
                globalActions.setIsAnalyzed(true);
            }

            if (is_analyzed === true) {
                setIsLoadingISBN(false);
                await initProductScreen(calcusoAI);
                setIsLoading(false);
            }

            initDisplayProductCard();
        };

        init();
    }, []);

    const analyze = () => {
        const startTime = Date.now();
        let countdownFired = false;
        let resultsFetched = false;

        const showBookMessage = () => {
            if (!countdownFired) {
                countdownFired = true;
            }
            setExtendedMessage(t("We're tracking down the exact editions for the books on your list. This takes a little longer — hang tight, you're almost there!"));
        };

        const fetchAndShowResults = async (keepLoadingISBN = false) => {
            setIsWaiting(false);
            setIsLoading(false);
            if (!keepLoadingISBN) {
                setIsLoadingISBN(false);
            }

            const fullResponse = await callAPI();
            const {precheck_text, translated_precheck_text} = fullResponse.data;
            setPreCheckText(translated_precheck_text || precheck_text);

            const document = fullResponse.data?.apiData?.documents[0];
            if (document) {
                globalActions.addPreviousUuid(uuid, document.original_url ?? document.document_url);
            }

            let aiData = await globalActions.reStructureCalcusoAI(fullResponse.data);
            await initProductScreen(aiData);
        };

        const interval = setInterval(async () => {
            const elapsed = Date.now() - startTime;

            if (elapsed > 300_000) {
                clearInterval(interval);
                setIsWaiting(false);
                setExtendedMessage(t("Oops, something took longer than expected. Please try uploading your parent letter again!"));
                return;
            }

            try {
                const res = await apiCRM.get('/ai/request/' + uuid + '/status');
                const {status, book_ratio, pending_books} = res.data;

                // 45s threshold — only applies while still processing
                if (elapsed > 45_000 && !countdownFired) {
                    countdownFired = true;
                    if (book_ratio >= 0.6) {
                        showBookMessage();
                    } else {
                        setIsWaiting(false);
                    }
                }

                if (status === 'completed') {
                    if ((book_ratio > 0.6 && pending_books > 0)) {
                        // Books still resolving — stay on Waiting screen with book message
                        showBookMessage();
                        return;
                    }

                    if (book_ratio > 0.6 && pending_books === 0) {
                        // All books resolved — fetch once and show products
                        clearInterval(interval);
                        await fetchAndShowResults(false);
                        return;
                    }

                    // book_ratio ≤ 0.6 — show products immediately, books render as placeholders
                    if (!resultsFetched) {
                        resultsFetched = true;
                        clearInterval(interval);
                        await fetchAndShowResults(pending_books > 0);
                    }
                    return;
                }

                if (status === 'error') {
                    clearInterval(interval);

                    const fullResponse = await callAPI();
                    let aiData = await globalActions.reStructureCalcusoAI(fullResponse.data);
                    if (aiData.is_not_found_product === true) {
                        setIsWaiting(false);
                    } else {
                        setIsWaiting(false);
                        setIsLoading(false);
                        setIsLoadingISBN(false);
                        await initProductScreen(aiData);
                    }
                    return;
                }
            } catch (e) {
                console.error('Status poll error:', e);
            }
        }, 3000);
    };

    const callAPI = async () => {
        return apiCRM.get('/ai/request/' + uuid);
    };

    const verifyParentLetter = (response) => {
        const {apiData} = response;
        const {documents} = apiData;
        let allIsNotParentLetter = true;

        documents.map((document) => {
            if (document.is_parent_letter !== true && document.is_parent_letter !== null) {
                allIsNotParentLetter = false;
            }
        });

        return allIsNotParentLetter;
    };

    const initProductScreen = async (aiData) => {
        const { items, settings } = aiData;
        const cart_rules = settings?.cart_rules;
        setItems(null);
        setItems(items);
        setCartRules(cart_rules || null);
        setSettings(settings || {});

        if (!is_analyzed) {
            items.forEach((_, index) => {
                let duration = 1000;

                setTimeout(() => {
                    if (index === 0) {
                        duration = 5000;
                    }

                    if (index > 1) {
                        setCurrentCardIndex(items?.length - 1);
                    } else {
                        setCurrentCardIndex(index);
                    }
                }, (index + 1) * duration);
            });
        } else {
            setCurrentCardIndex(items.length - 1);
        }

        initCartItems();
        try {
            mixpanel.track_pageview({"page": "ProductScreen"})
            ga4.pageview('/calcuso-ai-product-screen', '/calcuso-ai-product-screen', 'AI | Product Screen');
            
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'calcuso-ai-product-screen',
                    page_path: '/calcuso-ai-product-screen',
                    page_title: 'AI | Product Screen',
                });
            }
        } catch (e) {
            console.error("Error pushing to dataLayer:", e);
        }
    };

    const initCartItems = () => {
        const {fakeCart} = globalState;
        const {items} = fakeCart;
        setCartItem(items);
    }

    const toggleCardVisibility = (itemId) => {
        const {simpleItems} = calcusoAI;

        simpleItems.map((item) => {
            if (item.item_id === itemId && item?.productIds?.length === 0) {
                globalActions.setIsDisplay(itemId);
            }
        });

        items.map((item) => {
            if (item.item_id === itemId) {
                const cartProduct = cartItem[item?.main_product?.product_id];

                if (cartProduct !== undefined) {
                    globalActions.setIsDisplay(itemId);
                }
            }
        });
    };

    const displayProductCard = (index) => {
        const {simpleItems} = calcusoAI;

        if (simpleItems === undefined) {
            return true;
        }

        return simpleItems[index]?.is_display;
    };

    const initDisplayProductCard = () => {
        if (items) {
            items.map((aiItem) => {
                const cartProduct = cartItem[aiItem?.main_product?.product_id];

                if (!cartProduct) {
                    globalActions.setIsDisplay(aiItem.item_id, true);
                }
            });
        }
    }

    const handleNextStep = () => {
        const {fakeCart} = globalState;
        const {items} = fakeCart;

        if (Object.keys(items).length === 0) {
            toast.error(t('Please add at least one product to the cart'));
        } else {
            navigatingToCart.current = true;
            history.push('/cart/');
        }
    }

    const handleBack = () => {
        history.push('/upload/');
    }

    const handleBackToWebshop = () => {
        window.location.href = Config.stores[store?.id];
    }

    return (
        <AppLayout
            contentBackgroundColor="bg-cal-primary-celadon-green-E5F8F7"
            textColor="text-gunmetal-black"
            border={false}
        >
            <div className="flex flex-col">
                <Helmet>
                    <title>{('CALCUSO MatchBuddy')}</title>
                </Helmet>
                <div className="sticky top-0 bg-cal-primary-celadon-green-E5F8F7 z-20">
                    {!isWaiting && (
                        <FreeShipBanner />
                    )}
                    <HeaderAI confirm={true} title={('CALCUSO MatchBuddy')} subTitle={t('MatchBuddy')} setOpen={setOpen} isShowSmallMenu={!isWaiting}>
                    </HeaderAI>
                </div>

                <div className={classNames({
                    "z-10": isWaiting,
                    "transition-opacity duration-500 opacity-0 hidden": !isWaiting,
                })}>
                    <Waiting preCheckText={preCheckText} extendedMessage={extendedMessage}/>
                </div>

                <div className={classNames({
                    "absolute inset-0 bg-cal-primary-celadon-green-E5F8F7 bg-opacity-70 flex items-center justify-center": true,
                    "flex z-10": isLoadingRedirect,
                    "transition-opacity duration-500 opacity-0 z-0": !isLoadingRedirect,
                })}>
                    <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-gray-900"></div>
                </div>

                <div>
                    {uuid ? (
                        <div className={classNames({
                            "hidden": isWaiting,
                            "transition-opacity duration-500 opacity-100 block": !isWaiting,
                        })}>
                            <div className="flex flex-col h-full min-h-screen">
                                <div className="flex flex-col items-center flex-1 h-full pb-28 md:pt-10 relative">
                                    {items?.length > 0 && (
                                        <>
                                            <div className="font-bold md:text-2xl text-lg md:pb-5 pb-0">
                                                {t('Choose your products')}
                                            </div>
                                            {items.map((item, index) => (
                                                    <CardItem isLoadingISBN={isLoadingISBN} isLoading={isLoading} index={index} item={item} displayProductCard={displayProductCard} toggleCardVisibility={toggleCardVisibility} currentCardIndex={currentCardIndex} cartItem={cartItem}/>
                                                )
                                            )}
                                            {cartRules && Object.values(cartRules).map((rule) => (
                                                <CardFreeProduct freeProduct={rule.product} cartTotal={rule.cart_total}/>
                                            ))}
                                        </>
                                    )}

                                    {!isWaiting && is_not_found_product && !is_calcuso_parent_letter && (
                                        <div className="flex justify-center items-center flex-1 h-full">
                                            <div className="font-medium text-lg md:text-2xl text-center space-y-4 pb-32 px-6">
                                                <div className="flex flex-col space-y-4 items-center bg-white rounded-lg py-4 px-6">
                                                    <div>
                                                        <img className="w-16" src={PEEKAPOO_MONKEY} />
                                                    </div>
                                                    <div>
                                                        {t("I think this is not a parent letter.")}
                                                    </div>
                                                    <div>
                                                        {preCheckText}
                                                    </div>

                                                    <div className="pt-4">
                                                        <Button
                                                            onClick={handleBack}
                                                            type="button"
                                                            color="bg-gunmetal-black-600 hover:bg-gunmetal-black-700 focus:ring-gunmetal-black-500"
                                                            size={window.innerWidth < 640 ? "base" : "xl"}
                                                        >
                                                            <span>{t("Try again")}</span>
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span className="cursor-pointer text-sm text-cal-primary-celadon-green-008E8D" onClick={handleBackToWebshop}>{t("Back to the webshop")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {!isWaiting && is_calcuso_parent_letter && (
                                        <div className="block">
                                            <div className="flex flex-col w-full items-center my-5">
                                                <img
                                                    src={GO_IMG}
                                                    alt="Group Order"
                                                    className="flex-shrink-0 w-auto h-72"
                                                />
                                            </div>
                                            <div className="font-medium text-lg text-center px-6 pt-4">
                                                {t("You have uploaded a parent letter from the CALCUSO group order.")}
                                            </div>

                                            {group_order_school_code && (
                                                <>
                                                    <div className="font-medium text-lg text-center px-6 pt-4">
                                                        <span className="text-red-600">{t("Schoolcode")}: </span>
                                                        {group_order_school_code}
                                                    </div>
                                                    <div className="pt-4 flex justify-center">
                                                        <Button
                                                            type="button"
                                                            color="mx-auto bg-cal-primary-celadon-green-00B5B1 hover:bg-cal-primary-celadon-green-00B5B1 focus:bg-cal-primary-celadon-green-00B5B1 font-bold text-cal-primary-floral-white-FEFCF6 focus:ring-cal-primary-celadon-green-00B5B1"
                                                            size={window.innerWidth < 640 ? "base" : "xl"}
                                                            onClick={() => document.location.href = Config.apiGO + '/#/group-orders/' + group_order_school_code}
                                                        >
                                                            {t("Go to group order")}
                                                        </Button>
                                                    </div>
                                                </>
                                            )}

                                            {!group_order_school_code && (
                                                <>
                                                    <div className="font-medium text-lg text-center px-6 pt-4">
                                                        {t("Input the school code in the top right corner of the parent letter.")}
                                                    </div>
                                                    <Formik
                                                        enableReinitialize
                                                        initialValues={{
                                                            school_code: '',
                                                        }}
                                                        validationSchema={Yup.object().shape({
                                                            school_code: Yup.string().required(t("This field is required")),
                                                        })}
                                                        onSubmit={async (values) => {
                                                            setIsLoadingRedirect(true)
                                                            const response = await api.get('/calcuso-group-order/' + values.school_code);

                                                            if (response.data.payload?.school_code) {
                                                                document.location.href = Config.apiGO + '/#/group-orders/' + values.school_code;
                                                            } else {
                                                                await setIsLoading(false)
                                                                toast.error(t("The school code is not correct"));
                                                            }
                                                        }}
                                                        validateOnChange>
                                                        {({errors, touched, handleSubmit, values, handleChange, handleBlur, isValid, setValues}) => (
                                                            <form onSubmit={handleSubmit} className="w-full px-2 md:px-4 lg:px-8">
                                                                <ScrollToFieldError/>
                                                                <div className="px-4 mt-3 md:px-6 lg:px-8">
                                                                    <div className="flex flex-col space-y-4 w-96 mx-auto">
                                                                        <Input
                                                                            name="school_code"
                                                                            placeholder={t("123abc456")}
                                                                            onChange={e => handleChange(e)}
                                                                            onBlur={handleBlur}
                                                                            value={values.school_code}
                                                                            required
                                                                            error={touched.school_code && errors.school_code}
                                                                            errorMessage={errors.school_code}
                                                                        />

                                                                        <Button
                                                                            type="submit"
                                                                            color="mx-auto bg-cal-primary-celadon-green-00B5B1 hover:bg-cal-primary-celadon-green-00B5B1 focus:bg-cal-primary-celadon-green-00B5B1 font-bold text-cal-primary-floral-white-FEFCF6 focus:ring-cal-primary-celadon-green-00B5B1"
                                                                            size={window.innerWidth < 640 ? "base" : "xl"}
                                                                        >
                                                                            <span>{t("Go to group order")}</span>
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )}
                                                    </Formik>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {!isWaiting && !items?.length && !is_not_found_product && !is_calcuso_parent_letter && extendedMessage && (
                                        <div className="flex justify-center items-center flex-1 h-full">
                                            <div className="text-center space-y-4 pb-32 px-6">
                                                <div className="flex flex-col space-y-4 items-center bg-white rounded-lg py-6 px-8 max-w-sm mx-auto shadow-sm">
                                                    <div className="flex gap-1">
                                                        <span className="w-2 h-2 rounded-full bg-cal-primary-celadon-green-01A7A3 animate-bounce" style={{animationDelay: '0ms'}}/>
                                                        <span className="w-2 h-2 rounded-full bg-cal-primary-celadon-green-01A7A3 animate-bounce" style={{animationDelay: '150ms'}}/>
                                                        <span className="w-2 h-2 rounded-full bg-cal-primary-celadon-green-01A7A3 animate-bounce" style={{animationDelay: '300ms'}}/>
                                                    </div>
                                                    <div className="text-base font-medium text-gray-700 leading-relaxed">
                                                        {extendedMessage}
                                                    </div>
                                                    <Button
                                                        onClick={handleBack}
                                                        type="button"
                                                        color="bg-gunmetal-black-600 hover:bg-gunmetal-black-700 focus:ring-gunmetal-black-500"
                                                        size={window.innerWidth < 640 ? "base" : "xl"}
                                                    >
                                                        <span>{t("Try again")}</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                < /div>
                            </div>
                            <div className={classNames({
                                "fixed inset-x-0 bottom-0 opacity-0": true,
                                "transition-opacity duration-300 opacity-100": !isWaiting && items?.length > 0,
                            })}>
                                {teacherEdition?.is_teacher ? (
                                    <TeacherEditionV3/>
                                ) : (
                                    <div className="border-t-2 bg-cal-primary-floral-white-F5F0E1 lg:bg-cal-primary-floral-white-FEFCF6 border-floral-white-800">
                                        <div className="max-w-2xl px-4 py-2 mx-auto lg:max-w-7xl md:px-54 md:py-6 lg:px-8 lg:py-8">
                                            <div className="flex items-center justify-between space-x-4">
                                                <FakeCart showMobile/>
                                                <div className="flex items-center justify-end space-x-4">
                                                    <Button
                                                        type="button"
                                                        color="bg-gunmetal-black-600 hover:bg-gunmetal-black-700 focus:ring-gunmetal-black-500"
                                                        size={window.innerWidth < 640 ? "base" : "xl"}
                                                        onClick={handleNextStep}
                                                    >
                                                        <span>{t("next")}</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <ProductModal/>
                            <FakeCartModal/>
                            <ConfirmModal/>
                            <SideBarMenu open={open} setOpen={setOpen}/>
                        </div>
                    ) : (
                        <Redirect to="/"/>
                    )}
                </div>
            </div>
        </AppLayout>
    );
};
